import React, { useState } from "react";
import './LiveMatch.css'
import { useLocation, useNavigate } from "react-router-dom";
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";

const LiveMatchHeader = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const myState = location.state;
  const userInfo = Helper();
  const param = location?.state?.activeCasino || "ezugi";

  const [loading, setLoading] = useState(false); // Loader state

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(userData),
    };

    setLoading(true); // Show loader
    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        } else if (status === "VALIDATION_ERROR" || status === "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status === "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setLoading(false); // Hide loader after request
      });
  }

  return (
    <div className="bg-white shadow-sm lg:pl-[18rem] relative">

      {/* Loader Overlay */}
      {loading && (
        <div className="loader-overlay">
          <div className="loader-content">
            <div className="spinner"></div>
            <p>Launching Multimarket...</p>
          </div>
        </div>
      )}

      <div className="text-start px-2 bg-cyan-500">
        <p className="font-medium">In-Play</p>
      </div>
      <div className="overflow-x-auto">
        <div className="bg-white">
          <ul className="flex space-x-1 py-2 px-1">
            <li className="w-1/8 min-w-[71px]" onClick={() => navigate('/', { state: { myKey: "inplay", subSport: "live" } })}>
              <div className="flex flex-col items-center text-gray-700 hover:text-blue-600">
                <span className="inline-block bg-no-repeat watchlive"></span>
                <span className="text-xs mt-1 text-black font-bold">Watch Live</span>
              </div>
            </li>
            <li className="w-1/8 min-w-[71px]" onClick={() => navigate('/', { state: { myKey: "inplay", subSport: "live" } })}>
              <div className="flex flex-col items-center text-black-600">
                <span className="inline-block bg-no-repeat AllGame"></span>
                <span className="text-xs font-bold mt-1 text-black ">All Games</span>
              </div>
            </li>
            <li className="w-1/8 min-w-[71px]" onClick={() => navigate('/', { state: { myKey: "inplay", subSport: 4 } })}>
              <div className="flex flex-col items-center text-gray-700 hover:text-blue-600">
                <span className="relative crickets">
                  <span className="absolute -top-[-12px] -right-0 bg-red-700 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center ">1</span>
                  <span className="inline-block bg-no-repeat"></span>
                </span>
                <span className="text-xs mt-1 text-black font-bold">Cricket</span>
              </div>
            </li>
            <li className="w-1/8 min-w-[71px]" onClick={() => navigate('/', { state: { myKey: "inplay", subSport: 1 } })}>
              <div className="flex flex-col items-center text-gray-700 hover:text-blue-600">
                <span className="relative soccer">
                  <span className="absolute -top-[-12px] -right-0 bg-red-700 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">0</span>
                  <span className="inline-block bg-no-repeat"></span>
                </span>
                <span className="text-xs mt-1 text-black font-bold">Soccer</span>
              </div>
            </li>
            <li className="w-1/8 min-w-[71px]" onClick={() => navigate('/', { state: { myKey: "inplay", subSport: 2 } })}>
              <div className="flex flex-col items-center text-gray-700 hover:text-blue-600">
                <span className="relative tennis">
                  <span className="absolute -top-[-12px] -right-0 bg-red-700 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">0</span>
                  <span className="inline-block bg-no-repeat"></span>
                </span>
                <span className="text-xs mt-1 text-black font-bold">Tennis</span>
              </div>
            </li>
            <li className="w-1/8 min-w-[71px]" onClick={() => CreateAndLaunchWCOCasino(`BT`, ``, `EV`)}>
              <div className="flex flex-col items-center text-gray-700 hover:text-blue-600">
                <span className="relative multimarket">
                  <span className="inline-block bg-no-repeat"></span>
                </span>
                <span className="text-xs mt-1 text-black font-bold">Multimarket</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LiveMatchHeader;
